<template>
  <div>
    <template v-if="viaje.id">
      <!-- CARD PERSONA -->
      <template v-for="(reserva, index) in resumenReservas" :key="reserva.id">
        <div class="card-persona mb-10">
          <div
            class="persona-header d-flex align-items-center justify-content-between py-3 bg-primary-light"
            :class="[
              { collapsed: isCollapsed[index], 'opacity-50': reserva.estado === ESTADOS_RESERVA.CANCELADA },
              isMisReservas ? 'px-20' : 'px-15',
            ]"
            @click="toggleCollapse(index)">
            <div class="d-flex align-items-center flex-grow-1">
              <div class="icono-persona me-2">
                <IconOccupied
                  :user="reserva.usuario && reserva.usuario.nombre ? reserva.usuario : getUserForIcon(index)"
                  :all-colors="true"
                  :thin-border="true" />
              </div>
              <div class="d-flex align-items-center flex-wrap">
                <span
                  class="fs-16 fw-medium"
                  :class="reserva.estado === ESTADOS_RESERVA.CANCELADA ? 'text-danger' : 'text-primary'">
                  <template v-if="reserva.usuario && reserva.usuario.nombre">
                    {{ reserva.usuario.nombre }} {{ reserva.usuario.apellido }}
                  </template>
                  <template v-else>
                    <span>{{ $t('general.persona') }} {{ index + 1 }}/</span>
                    <span>{{ alojamiento && alojamientoHasHabs ? alojamiento.habitacion.numPlazas : resumenReservas.length}}</span>
                  </template>
                </span>
                <template v-if="reserva.estado === ESTADOS_RESERVA.CANCELADA">
                  <span class="badge text-bg-danger ms-2 translate">{{ reserva.estado }}</span>
                  <button
                    type="button"
                    class="btn btn-link btn-sm text-decoration-underline p-0 ms-2"
                    @click.stop="recuperarReserva">
                    {{ $t('reserva.recuperarReserva') }}
                  </button>
                </template>
              </div>
            </div>
            <CustomIcon
              v-if="!reserva.hasConflictoEdad"
              :icon="isCollapsed[index] ? arrowDownIcon : arrowUpIcon"
              size="14px"
              class="pointer text-primary" />
          </div>

          <div v-if="reserva.hasConflictoEdad" class="p-15 text-primary">
            {{ $t('servicios.sinServicioValidoEdad') }}
          </div>
          <transition name="collapse">
            <div v-show="!isCollapsed[index] && !reserva.hasConflictoEdad" class="collapse-content">
              <!-- SERVICIOS INCLUIDOS -->
              <div :class="isMisReservas ? 'px-20 py-15' : 'p-15'" class="text-primary">
                <div class="d-flex justify-content-between align-items-center mb-10">
                  <span class="fw-bold fs-m-13" :class="isMisReservas ? 'fs-16' : 'fs-13'">{{
                    $t('input.field.incluidPaqueteBasico')
                  }}</span>
                  <span class="fw-bold text-primary fs-m-13" :class="isMisReservas ? 'fs-16' : 'fs-13'">
                    <template v-if="reserva.precioBasico && reserva.precioBasico > 0">
                      {{ formatPrice(reserva.precioBasico) }} {{ agenciaStore.getCurrency }}
                    </template>
                    <template v-else>
                      {{ formatPrice(reserva.precioDesdeViaje) }} {{ agenciaStore.getCurrency }}
                    </template>
                  </span>
                </div>
                <!-- ALOJAMIENTO -->
                <template v-if="alojamiento">
                  <div class="servicio-item mb-10 text-primary">
                    <div class="d-flex align-items-start">
                      <img
                          :src="viaje.cabeceraAlojamientos?.icono ?? accommodationIcon"
                          class="servicio-icon text-primary"
                          :style="{ width: isMisReservas ? '16px' : '14px', height: isMisReservas ? '16px' : '14px' }"
                          :alt="alojamiento.nombre" />
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center">
                          <div class="me-2 title-servicio fs-m-13" :class="isMisReservas ? 'fs-16' : 'fs-13'">
                            {{ alojamiento.nombre }}
                          </div>
                          <a
                            href="#"
                            class="text-primary fs-11 fs-m-11 text-decoration-underline pointer title-servicio"
                            @click.prevent="goToAlojamiento(alojamiento.id)">
                            + {{ $t('general.info') }}
                          </a>
                        </div>
                        <div
                          class="descripcion-servicio text-primary-light fs-m-11"
                          :class="isMisReservas ? 'fs-13' : 'fs-11'">
                          {{ alojamiento.descripcion }}
                        </div>
                        <div class="text-primary-light fs-m-11" :class="isMisReservas ? 'fs-13' : 'fs-11'">
                          {{ getAlojamientoInfo(alojamiento) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- SERVICIOS INCLUYE  -->
                <template v-for="incluye in incluyesFiltrados" :key="incluye.nombre">
                  <div class="servicio-item mb-10 text-primary">
                    <div class="d-flex align-items-start">
                      <img
                        v-if="incluye.imagen"
                        :src="incluye.imagen"
                        class="servicio-icon text-primary"
                        :style="{ width: isMisReservas ? '16px' : '14px', height: isMisReservas ? '16px' : '14px' }"
                        :alt="incluye.nombre" />
                      <CustomIcon
                        v-else
                        :icon="activityIcon"
                        class="servicio-icon text-primary"
                        :size="isMisReservas ? '16px' : '14px'" />
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center">
                          <div class="translate me-2 fs-m-13" :class="isMisReservas ? 'fs-16' : 'fs-13'">
                            {{ incluye.nombre }}
                          </div>
                        </div>
                        <div
                          v-if="incluye.descripcion"
                          class="descripcion-servicio text-primary-light translate fs-m-11"
                          :class="isMisReservas ? 'fs-13' : 'fs-11'">
                          {{ incluye.descripcion }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- SERVICIOS PAQUETE BASICO -->
                <template v-for="swc in getServiciosPaqueteBasico(reserva)" :key="swc.servicio.id">
                  <div v-if="swc.servicio.paqueteBasico" class="servicio-item mb-10 text-primary">
                    <div class="d-flex align-items-start">
                      <template v-if="getServiceIcon(swc.servicio).type === TipoIconoServicio.IMAGE">
                        <img
                          :src="getServiceIcon(swc.servicio).value"
                          class="servicio-icon text-primary"
                          :style="{ width: isMisReservas ? '16px' : '14px', height: isMisReservas ? '16px' : '14px' }"
                          :alt="swc.servicio.nombre" />
                      </template>
                      <template v-if="getServiceIcon(swc.servicio).type === TipoIconoServicio.ICON">
                        <CustomIcon
                          :icon="getServiceIcon(swc.servicio).value"
                          class="servicio-icon text-primary"
                          :size="isMisReservas ? '16px' : '14px'" />
                      </template>
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center">
                          <div
                            class="translate mb-1 me-2 title-servicio fs-m-13"
                            :class="isMisReservas ? 'fs-16' : 'fs-13'">
                            {{ swc.servicio.nombre }}
                          </div>
                          <a
                            v-if="swc.servicio.infoExtra"
                            href="#"
                            class="text-primary fs-11 fs-m-11 text-decoration-underline pointer title-servicio"
                            data-bs-toggle="modal"
                            :data-bs-target="`#infoExtraModalPB${reserva.id}-${swc.servicio.id}`"
                            @click.prevent.stop>
                            + {{ $t('general.info') }}
                          </a>
                          <button
                            v-if="
                              isMisReservas &&
                              swc.servicio.seguro &&
                              swc.servicio.subtipo === 'cancelacion' &&
                              reserva.documentacionSeguroCancelacion
                            "
                            class="btn-recibo p-0 text-decoration-underline text-primary fs-11 fw-semibold ms-2"
                            @click.stop="descargarDocumentacion(reserva)">
                            <DownloadIcon class="me-1" />
                            {{ $t('botones.documentacion') }}
                          </button>
                        </div>
                        <div
                          v-if="swc.servicio.descripcion"
                          class="descripcion-servicio text-primary-light translate fs-m-11"
                          :class="isMisReservas ? 'fs-13' : 'fs-11'">
                          {{ swc.servicio.descripcion }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- SERVICIOS PAQUETE BASICO REMPLAZADOS -->
                <template
                  v-for="swc in getServiciosPaqueteBasicoUpsell(reserva)"
                  :key="`reemplazado-${swc.servicioPB.id}`">
                  <div class="servicio-item mb-10 text-primary">
                    <div class="d-flex align-items-start">
                      <template v-if="getServiceIcon(swc.servicioPB).type === TipoIconoServicio.IMAGE">
                        <img
                          :src="getServiceIcon(swc.servicioPB).value"
                          class="servicio-icon text-primary"
                          :style="{ width: isMisReservas ? '16px' : '14px', height: isMisReservas ? '16px' : '14px' }"
                          :alt="swc.servicioPB.nombre" />
                      </template>
                      <template v-if="getServiceIcon(swc.servicioPB).type === TipoIconoServicio.ICON">
                        <CustomIcon
                          :icon="getServiceIcon(swc.servicioPB).value"
                          class="servicio-icon text-primary"
                          :size="isMisReservas ? '16px' : '14px'" />
                      </template>
                      <div class="flex-grow-1">
                        <div
                          class="translate text-decoration-line-through title-servicio fs-m-13"
                          :class="isMisReservas ? 'fs-16' : 'fs-13'">
                          {{ swc.servicioPB.nombre }}
                        </div>
                        <div
                          v-if="swc.servicioPB.descripcion"
                          class="descripcion-servicio text-primary-light translate text-decoration-line-through fs-m-11"
                          :class="isMisReservas ? 'fs-13' : 'fs-11'">
                          {{ swc.servicioPB.descripcion }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- SERVICIOS UPSELL -->
                <template v-for="swc in getServiciosPaqueteBasicoUpsell(reserva)" :key="`upsell-${swc.servicio.id}`">
                  <div class="servicio-item mb-10 text-primary">
                    <div class="d-flex align-items-start justify-content-between">
                      <div class="d-flex align-items-start flex-grow-1">
                        <template v-if="getServiceIcon(swc.servicio).type === TipoIconoServicio.IMAGE">
                          <img
                            :src="getServiceIcon(swc.servicio).value"
                            class="servicio-icon text-primary"
                            :style="{ width: isMisReservas ? '16px' : '14px', height: isMisReservas ? '16px' : '14px' }"
                            :alt="swc.servicio.nombre" />
                        </template>
                        <template v-if="getServiceIcon(swc.servicio).type === TipoIconoServicio.ICON">
                          <CustomIcon
                            :icon="getServiceIcon(swc.servicio).value"
                            class="servicio-icon text-primary"
                            :size="isMisReservas ? '16px' : '14px'" />
                        </template>
                        <div class="flex-grow-1">
                          <div class="d-flex align-items-center">
                            <div
                              class="translate mb-1 me-2 title-servicio fs-m-13"
                              :class="isMisReservas ? 'fs-16' : 'fs-13'">
                              {{ swc.servicio.nombre }}
                            </div>
                            <a
                              v-if="swc.servicio.infoExtra"
                              href="#"
                              class="text-primary fs-11 fs-m-11 text-decoration-underline pointer title-servicio"
                              data-bs-toggle="modal"
                              :data-bs-target="`#infoExtraModalUpsell${reserva.id}-${swc.servicio.id}`"
                              @click.prevent.stop>
                              + {{ $t('general.info') }}
                            </a>
                          </div>
                          <div
                            v-if="swc.servicio.descripcion"
                            class="descripcion-servicio text-primary-light translate fs-m-11"
                            :class="isMisReservas ? 'fs-13' : 'fs-11'">
                            {{ swc.servicio.descripcion }}
                          </div>
                          <div
                            v-if="swc.servicio.firstFilter || swc.servicio.secondFilter"
                            class="text-primary-light fs-m-11"
                            :class="isMisReservas ? 'fs-13' : 'fs-11'">
                            {{ swc.servicio.firstFilter?.nombre }} / {{ swc.servicio.secondFilter?.nombre }}
                          </div>
                        </div>
                      </div>
                      <div class="fw-bold text-primary" :class="isMisReservas ? 'fs-16' : 'fs-13'">
                        {{ getPrecioIncremento(swc) > 0 ? '+' : '' }}{{ formatPrice(getPrecioIncremento(swc)) }}
                        {{ agenciaStore.getCurrency }}
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <div class="divisor-horizontal ml-15 mr-15" />

              <!-- SERVICIOS EXTRAS -->
              <template v-if="getServiciosExtras(reserva).length > 0">
                <div :class="isMisReservas ? 'px-20 py-15' : 'p-15'" class="text-primary">
                  <div class="fw-bold mb-10" :class="isMisReservas ? 'fs-16' : 'fs-13'">
                    {{ $t('reserva.extras') }}
                  </div>

                  <template v-for="swc in getServiciosExtras(reserva)" :key="swc.servicio.id">
                    <div class="servicio-item mb-10 text-primary">
                      <div class="d-flex align-items-start justify-content-between">
                        <div class="d-flex align-items-start flex-grow-1">
                          <template v-if="getServiceIcon(swc.servicio).type === TipoIconoServicio.IMAGE">
                            <img
                              :src="getServiceIcon(swc.servicio).value"
                              class="servicio-icon"
                              :style="{
                                width: isMisReservas ? '16px' : '14px',
                                height: isMisReservas ? '16px' : '14px',
                              }"
                              :alt="swc.servicio.nombre" />
                          </template>
                          <template v-if="getServiceIcon(swc.servicio).type === TipoIconoServicio.ICON">
                            <CustomIcon
                              :icon="getServiceIcon(swc.servicio).value"
                              class="servicio-icon"
                              :size="isMisReservas ? '16px' : '14px'" />
                          </template>
                          <div class="flex-grow-1">
                            <div class="d-flex align-items-center">
                              <div
                                class="translate mb-1 me-2 title-servicio fs-m-13"
                                :class="isMisReservas ? 'fs-16' : 'fs-13'">
                                {{ swc.servicio.nombre }}
                              </div>
                              <a
                                v-if="swc.servicio.infoExtra"
                                href="#"
                                class="text-primary fs-11 fs-m-11 text-decoration-underline pointer title-servicio"
                                data-bs-toggle="modal"
                                :data-bs-target="`#infoExtraModalExtra${reserva.id}-${swc.servicio.id}`"
                                @click.prevent.stop>
                                + {{ $t('general.info') }}
                              </a>
                              <button
                                v-if="
                                  isMisReservas &&
                                  swc.servicio.seguro &&
                                  swc.servicio.subtipo === 'cancelacion' &&
                                  reserva.documentacionSeguroCancelacion
                                "
                                class="btn-recibo ms-2"
                                @click.stop="descargarDocumentacion(reserva)">
                                <DownloadIcon class="me-1" />
                                {{ $t('botones.documentacion') }}
                              </button>
                            </div>
                            <div
                              v-if="swc.servicio.descripcion"
                              class="descripcion-servicio text-primary-light translate fs-m-11"
                              :class="isMisReservas ? 'fs-13' : 'fs-11'">
                              {{ swc.servicio.descripcion }}
                            </div>
                            <div
                              v-if="swc.servicio.firstFilter || swc.servicio.secondFilter"
                              class="text-primary-light fs-m-11"
                              :class="isMisReservas ? 'fs-13' : 'fs-11'">
                              {{ swc.servicio.firstFilter.nombre }} / {{ swc.servicio.secondFilter.nombre }}
                            </div>
                          </div>
                        </div>
                        <div class="d-flex align-items-center" :class="isMisReservas ? 'fs-16' : 'fs-13'">
                          <template v-if="swc.cantidad > 1">
                            <span class="fw-normal me-1">{{ swc.cantidad }} x</span>
                          </template>
                          <span class="fw-bold">
                            {{ formatPrice(swc.servicio.precioTeorico || swc.servicio.precio) }}
                            {{ agenciaStore.getCurrency }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>

                <div class="divisor-horizontal ml-15 mr-15" />
              </template>

              <!-- COMPLEMENTOS -->
              <template
                v-if="
                  (reserva.complementos && reserva.complementos.length > 0) ||
                  (reserva.gastos && reserva.gastos.length > 0)
                ">
                <div class="p-15 text-primary">
                  <div class="fs-13 fw-bold mb-10">
                    {{ $t('reserva.suplementos.title') }}
                  </div>

                  <template v-for="complemento in reserva.complementos" :key="complemento.codigo">
                    <div class="d-flex justify-content-between align-items-center mb-10">
                      <span class="fs-13">{{ $t(`reserva.suplementos.${complemento.codigo}`) }}</span>
                      <span v-if="complemento.importe" class="fs-13 fw-bold">
                        {{ formatPrice(complemento.importe) }} {{ agenciaStore.getCurrency }}
                      </span>
                    </div>
                  </template>

                  <template v-for="gasto in reserva.gastos" :key="gasto.codigo">
                    <div class="d-flex justify-content-between align-items-center mb-10">
                      <span class="fs-13">{{ $t(`reserva.gastos.${gasto.codigo}`) }}</span>
                      <span v-if="gasto.importe" class="fs-13 fw-bold">
                        {{ formatPrice(gasto.importe) }} {{ agenciaStore.getCurrency }}
                      </span>
                    </div>
                  </template>
                </div>

                <div class="divisor-horizontal ml-15 mr-15" />
              </template>

              <!-- TASAS -->
              <div :class="isMisReservas ? 'px-20 py-15' : 'p-15'" class="text-primary">
                <div
                  v-if="reserva.precioBase > 0"
                  class="d-flex justify-content-between align-items-center"
                  :class="{
                    'mb-2':
                      storeHabitacion.getCodigoDescuento ||
                      reserva.tasasExternasCalculadas?.filter(t => t.importe > 0)?.length > 0 ||
                      reserva.tasasInternasCalculadas?.filter(t => t.importe > 0)?.length > 0,
                  }">
                  <span class="fw-bold" :class="isMisReservas ? 'fs-16' : 'fs-13'">
                    {{ $t('subtitulo.total').toUpperCase() }}
                  </span>
                  <span class="fw-bold" :class="isMisReservas ? 'fs-16' : 'fs-13'">
                    {{ formatPrice(reserva.precioBase) }} {{ agenciaStore.getCurrency }}
                  </span>
                </div>
                <!-- DESCUENTOS -->
                <template v-if="storeHabitacion.getCodigoDescuento">
                  <div class="fs-13 fw-bold mb-1">{{ $t('reserva.descuentos') }}</div>
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <div class="fs-11">
                      {{ storeHabitacion.getCodigoDescuento.descripcion }}
                      <span
                        class="text-primary text-decoration-underline ml-10 fs-11 cursor-pointer"
                        @click="limpiarCodigo">
                        {{ $t('actions.delete') }}
                      </span>
                    </div>
                    <span class="fw-bold text-secondary" :class="isMisReservas ? 'fs-16' : 'fs-13'">
                      -{{ formatPrice(reserva.descuento) }} {{ agenciaStore.getCurrency }}
                    </span>
                  </div>
                </template>
                <template
                  v-for="tasaExterna in reserva.tasasExternasCalculadas?.filter(t => t.importe > 0)"
                  :key="tasaExterna">
                  <div
                    class="d-flex justify-content-between align-items-center"
                    :class="{ 'mb-2': reserva.tasasInternasCalculadas?.filter(t => t.importe > 0)?.length > 0 }">
                    <span class="fw-bold" :class="isMisReservas ? 'fs-16' : 'fs-13'">
                      {{ $t(`reserva.tasas.externas.${tasaExterna.codigo}`) }}
                    </span>
                    <span class="fw-bold" :class="isMisReservas ? 'fs-16' : 'fs-13'">
                      {{ formatPrice(tasaExterna.importe) }} {{ agenciaStore.getCurrency }}
                    </span>
                  </div>
                </template>

                <template
                  v-for="tasaInterna in reserva.tasasInternasCalculadas?.filter(t => t.importe > 0)"
                  :key="tasaInterna">
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="fw-bold" :class="isMisReservas ? 'fs-16' : 'fs-13'">
                      {{ $t(`reserva.tasas.internas.${tasaInterna.codigo}`) }}
                    </span>
                    <span class="fw-bold" :class="isMisReservas ? 'fs-16' : 'fs-13'">
                      {{ formatPrice(tasaInterna.importe) }} {{ agenciaStore.getCurrency }}
                    </span>
                  </div>
                </template>
              </div>
            </div>
          </transition>
        </div>
      </template>

      <!-- IMPORTE TOTAL -->
      <div :class="isMisReservas ? 'px-20 py-15' : 'p-15'" class="card-total-final">
        <div class="d-flex justify-content-between align-items-center">
          <span class="fs-16 fw-bold text-white">{{ $t('subtitulo.importeTotal').toUpperCase() }}</span>
          <span class="fs-23 fw-bold text-white fs-m-16 fw-m-semibold">
            {{ formatPrice(calculaPrecioTotalReservas(resumenReservas)) }} {{ agenciaStore.getCurrency }}
          </span>
        </div>
      </div>
    </template>

    <!-- MODALES -->
    <Teleport to="body">
      <template v-for="reserva in resumenReservas" :key="`reserva-${reserva.id}`">
        <template
          v-for="swc in getServiciosPaqueteBasico(reserva).filter(s => s.servicio.infoExtra)"
          :key="`modal-incluido-${swc.servicio.id}`">
          <InfoExtraModal
            :modal-id="`infoExtraModalPB${reserva.id}-${swc.servicio.id}`"
            :title="swc.servicio.nombre"
            :content="swc.servicio.infoExtra" />
        </template>
        <template
          v-for="swc in getServiciosExtras(reserva).filter(s => s.servicio.infoExtra)"
          :key="`modal-extra-${swc.servicio.id}`">
          <InfoExtraModal
            :modal-id="`infoExtraModalExtra${reserva.id}-${swc.servicio.id}`"
            :title="swc.servicio.nombre"
            :content="swc.servicio.infoExtra" />
        </template>
        <template
          v-for="swc in getServiciosPaqueteBasicoUpsell(reserva).filter(s => s.servicio.infoExtra)"
          :key="`modal-upsell-${swc.servicio.id}`">
          <InfoExtraModal
            :modal-id="`infoExtraModalUpsell${reserva.id}-${swc.servicio.id}`"
            :title="swc.servicio.nombre"
            :content="swc.servicio.infoExtra" />
        </template>
      </template>
    </Teleport>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';
  import moment from 'moment';
  import { calculaPrecioTotalReservas } from '@/helpers/viajesGrupos';
  import { formatPrice } from '@/helpers/numberUtils';
  import { getCategoriasServiciosMetaData, TipoIconoServicio } from '@/helpers/serviciosUtils';
  import accommodationIcon from '@/assets/icons/alojamiento.svg';
  import IconOccupied from '@/components/Icons/IconOccupied.vue';
  import CustomIcon from '@/components/CustomIcon.vue';
  import arrowDownIcon from '@/assets/icons/arrow_down.svg';
  import arrowUpIcon from '@/assets/icons/arrow_up.svg';
  import { informacionHabitacion } from '@/store_pinia/informacionHabitacion';
  import { agenciaStoreModule } from '@/store_pinia/agencia';
  import InfoExtraModal from '@/components/modales/InfoExtraModal.vue';
  import activityIcon from '@/assets/icons/servicios/actividad.svg';
  import DownloadIcon from '@/components/Icons/DownloadIcon.vue';
  import { ESTADOS_RESERVA } from '@/constants/reservaConstants';

  const { t } = useI18n();
  const storeHabitacion = informacionHabitacion();
  const agenciaStore = agenciaStoreModule();
  const isCollapsed = ref([]);

  defineProps({
    isMisReservas: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(['limpiar-codigo-descuento', 'descuento-aplicado', 'recuperar-reserva']);

  const viaje = computed(() => storeHabitacion.getViaje);
  const alojamiento = computed(() => storeHabitacion.getAlojamiento);
  const resumenReservas = computed(() => storeHabitacion.getResumenReservas);
  const alojamientoHasHabs = computed(() => alojamiento.value && alojamiento.value.hasHabitaciones);

  const incluyesFiltrados = computed(() => {
    if (viaje.value.incluyes && viaje.value.incluyes.length > 0) {
      return viaje.value.incluyes
        .filter(({ nombre }) => nombre.toLowerCase() !== 'alojamiento')
        .filter(({ isIconoViaje }) => isIconoViaje);
    }
    return [];
  });

  function toggleCollapse(index) {
    isCollapsed.value[index] = !isCollapsed.value[index];
  }

  function getUserForIcon(index) {
    return {
      nombre: t('general.persona'),
      apellido: '',
      done: false,
      isFree: false,
      id: index + 1,
    };
  }

  function getServiciosPaqueteBasico(reserva) {
    if (!reserva.serviciosWithCantidad) {
      return [];
    }
    return Object.values(reserva.serviciosWithCantidad).filter(swc => swc.servicio.paqueteBasico);
  }

  function getServiciosPaqueteBasicoUpsell(reserva) {
    if (!reserva.serviciosWithCantidad) {
      return [];
    }
    return Object.values(reserva.serviciosWithCantidad).filter(
      swc => swc.categoriaPaqueteBasico && swc.servicioPB && swc.servicio.id !== swc.servicioPB.id
    );
  }

  function getServiciosExtras(reserva) {
    const extras = [];

    if (reserva.serviciosWithCantidad) {
      Object.values(reserva.serviciosWithCantidad).forEach(swc => {
        if (swc.servicio.nulo) return;

        // Servicios extras normales (no paquete, no upsell)
        if (!swc.servicio.paqueteBasico && !swc.categoriaPaqueteBasico) {
          extras.push(swc);
        }
        // Servicios extras de paquete basico con cantidad > 1 (extras)
        else if (swc.servicio.paqueteBasico && swc.cantidad > 1) {
          extras.push({
            ...swc,
            cantidad: swc.cantidad - 1,
          });
        }
        // Servicios upsell de paquete basico con cantidad > 1 (extras adicionales)
        else if (swc.categoriaPaqueteBasico && swc.cantidad > 1) {
          extras.push({
            ...swc,
            cantidad: swc.cantidad - 1, // Solo las unidades extras ( uno ya esta en incluidos)
          });
        }
      });
    }

    return extras;
  }

  function getServiceIcon(servicio) {
    const agrupacionesServicios = storeHabitacion.getAgrupacionesServicios;
    const agrupacionServicios = agrupacionesServicios.find(agrupacion => agrupacion.id === servicio.agrupacion?.id);

    if (!agrupacionServicios) {
      return { type: TipoIconoServicio.IMAGE, value: '' };
    }

    if (agrupacionServicios.icono) {
      return { type: TipoIconoServicio.IMAGE, value: agrupacionServicios.icono };
    } else {
      const serviciosMetaData = getCategoriasServiciosMetaData().find(
        ({ selector }) => selector === agrupacionServicios.tipo
      );
      if (serviciosMetaData?.icono) {
        return { type: TipoIconoServicio.ICON, value: serviciosMetaData.icono };
      }
    }
  }

  function getAlojamientoInfo(alojamiento) {
    const info = [];

    if (viaje.value.fechaInicio && viaje.value.fechaFin) {
      const inicio = moment(viaje.value.fechaInicio);
      const fin = moment(viaje.value.fechaFin);
      const noches = fin.diff(inicio, 'days');
      const nochesText = noches === 1 ? t('general.noche') : t('general.noches');
      info.push(`${noches} ${nochesText}`);
    }

    if (alojamiento.habitacion?.tipo?.nombre) {
      info.push(alojamiento.habitacion.tipo.nombre);
    }

    if (alojamiento.habitacion?.regimen) {
      const regimen = t(`reserva.tipo.${alojamiento.habitacion.regimen}`);
      info.push(regimen);
    }

    return info.join(' / ');
  }

  function goToAlojamiento(alojamientoId) {
    const url = `/alojamientos/${alojamientoId}`;
    window.open(url, '_blank');
  }

  function limpiarCodigo() {
    emit('limpiar-codigo-descuento');
  }

  function recuperarReserva() {
    emit('recuperar-reserva');
  }

  function descargarDocumentacion(reserva) {
    if (reserva?.documentacionSeguroCancelacion) {
      window.open(reserva.documentacionSeguroCancelacion, '_blank');
    }
  }

  function getPrecioIncremento(swc) {
    if (swc.categoriaPaqueteBasico && swc.servicioPB) {
      const newPrecio = swc.servicio.precioTeorico;
      const originalPrecio = swc.servicioPB.precioTeorico;
      return newPrecio - originalPrecio;
    }
    return 0;
  }

  onMounted(() => {
    isCollapsed.value = resumenReservas.value.map(() => false);
  });
</script>

<style lang="scss" scoped>
  .card-persona {
    border-radius: var(--bs-border-radius-xl);
    border: 1px solid rgba(var(--bs-primary-rgb), 0.2);
    background: white;

    .persona-header {
      background-color: rgba(var(--bs-primary-rgb), 0.1);
      border-top-left-radius: var(--bs-border-radius-xl);
      border-top-right-radius: var(--bs-border-radius-xl);

      &.collapsed {
        border-bottom-left-radius: var(--bs-border-radius-xl);
        border-bottom-right-radius: var(--bs-border-radius-xl);
      }

      .icono-persona {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;

        .icono-ocupado {
          width: 24px !important;
          height: 24px !important;
          font-size: 12px !important;
          border-width: 1px !important;
        }
      }
    }

    .servicio-item {
      .servicio-icon {
        width: 14px;
        height: 14px;
        font-size: 14px;
        margin-right: 8px;
        margin-top: 2px;
        flex-shrink: 0;
      }

      .descripcion-servicio {
        margin-bottom: 3px;
      }

      &:last-child {
        margin-bottom: 0 !important;
      }
    }

    .divisor-horizontal {
      border-top: 1px solid rgba(var(--bs-primary-rgb), 0.2);
    }
  }

  .card-total-final {
    background-color: var(--bs-primary);
    border-radius: var(--bs-border-radius-xl);
  }

  .text-primary-light {
    color: rgba(var(--bs-primary-rgb), 0.8);
  }

  .collapse-enter-active,
  .collapse-leave-active {
    transition: all 0.3s ease;
  }

  .collapse-enter-from,
  .collapse-leave-to {
    opacity: 0;
    max-height: 0;
  }

  .collapse-enter-to,
  .collapse-leave-from {
    opacity: 1;
    max-height: 1000px;
  }

  .btn-recibo {
    border: none;
    background: none;
    display: flex;
    align-items: center;
  }
</style>
